<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<p>Foreword by Shadé – Holistic Health Mentor</p><br/>
<p>There’s a difference between passion and purpose.</p><br/>
<p>You can be passionate about some things and still not be walking in your purpose.</p><br/>
<p>But if you are walking in your purpose, you will most certainly always be passionate.</p><br/>
<p>Passion is the vehicle that guides you to purpose. It’s the north star if you will for approaching big revelation for your life.</p><br/>
<p>Sometimes revelation comes like an unexpected lightning bolt that takes you by surprise lighting up the whole night sky giving you the biggest aha moment ever.</p><br/>
<p>Other times revelation comes in pieces like a 1,000 piece puzzle that you assemble bit by bit as you go along.</p><br/>
<p>But what do you do with those puzzle pieces or that big aha moment?</p><br/>
<p>When you’re able to see the vision, understand your purpose, but don’t see ‘the how’ it can feel overwhelming. You may feel blindsided or paralyzed by fear because you lack certain gifts to walk out the vision effectively.</p><br/>
<p>That’s when faith has to be activated.</p><br/>
<p>When you walk in your purpose God will confirm time and time again that you are exactly where you need to be.</p><br/>
<p>As you yield to Him, He will send help to fill in the gaps here and there. He will send strangers who become like family. He will send impartation of directions that come as a whisper, or felt like a light tap on the shoulder.</p><br/>
<p>It may not be understood by others,</p>
<p>But that’s not any of your concern.</p>
<p>Your end all goal is walking in obedience to build, and pursue something so much bigger than you.</p><br/>
<p>Remember…</p>
<p>God doesn’t call the qualified.</p>
<p>He qualifies the called.</p><br/>
<p>He’s called you child of God. Have you answered? Everything is in place. It’s time to walk with childlike faith. Passion is pulling and purpose is awaiting.</p><br/>
<p>Abundant blessings.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?535273c0